import React, { useState } from "react";
import { DatePicker, Form, InputNumber, Modal, Select } from "antd";
import { vouchers_venders } from "../../../utils/constants";
import dayjs from "dayjs";

const CreateVouchers = ({ open, setOpen, loading, handleFinish }) => {
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState();
  const onCreate = async (values) => {
    console.log("Received values of form: ", values);
    setFormValues(values);
    await handleFinish(values);
    form.resetFields();
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      title="Create a new collection"
      okText="Create"
      cancelText="Cancel"
      okButtonProps={{ autoFocus: true, htmlType: "submit", loading: loading }}
      onCancel={() => setOpen(false)}
      destroyOnClose
      modalRender={(dom) => (
        <Form
          layout="vertical"
          form={form}
          name="form_in_modal"
          initialValues={{ modifier: "public" }}
          clearOnDestroy
          onFinish={(values) => onCreate(values)}
        >
          {dom}
        </Form>
      )}
    >
      <Form.Item
        name="no_of_vouchers"
        label="Number of voucher"
        rules={[
          {
            required: true,
            message: "Please input the number of vouchers!",
          },
        ]}
      >
        <InputNumber
          className="full_width"
          placeholder="Enter the number of vouchers you want to generate"
        />
      </Form.Item>
      <Form.Item
        name="vendor"
        label="Select Vendor"
        rules={[
          {
            required: true,
            message: "Select a vendor",
          },
        ]}
      >
        <Select
          placeholder="Select an option"
          className="full_width"
          options={vouchers_venders?.map((item) => {
            return {
              label: item,
              value: item,
            };
          })}
        />
      </Form.Item>
      <Form.Item name="expires_at" label="Expires At">
        <DatePicker
          minDate={dayjs()}
          className="full_width"
          min={1}
          placeholder="Select expiry date"
          format="DD-MM-YYYY"
        />
      </Form.Item>
    </Modal>
  );
};
export default CreateVouchers;
